"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NFTProperties = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var react_2 = require("react");

var useMediaContext_1 = require("../context/useMediaContext");

var nft_hooks_1 = require("@zoralabs/nft-hooks");

var NFTDataContext_1 = require("../context/NFTDataContext");

var InfoContainer_1 = require("./InfoContainer");

var NFTProperties = function NFTProperties(_ref) {
  var className = _ref.className;

  var _react_2$useContext = react_2.useContext(NFTDataContext_1.NFTDataContext),
      data = _react_2$useContext.nft.data;

  var _useMediaContext_1$us = useMediaContext_1.useMediaContext(),
      getStyles = _useMediaContext_1$us.getStyles;

  var _nft_hooks_1$useNFTMe = nft_hooks_1.useNFTMetadata(data === null || data === void 0 ? void 0 : data.nft.metadataURI),
      metadata = _nft_hooks_1$useNFTMe.metadata;

  var renderAttributes = function renderAttributes(attributes) {
    function formatAttributes(obj) {
      if (Array.isArray(obj)) {
        return obj;
      } else {
        var array = Object.keys(obj).length === 0 ? false : Object.entries(obj);

        if (array !== false) {
          return array.map(function (a) {
            return {
              trait_type: a[0],
              value: a[1]
            };
          });
        } else {
          return [];
        }
      }
    }

    var formattedAttributes = formatAttributes(attributes);

    if (!attributes || !formattedAttributes.length) {
      return null;
    }

    return jsx_runtime_1.jsx(InfoContainer_1.InfoContainer, Object.assign({
      className: className,
      titleString: "PROPERTIES_TITLE"
    }, {
      children: jsx_runtime_1.jsx("div", Object.assign({}, getStyles("propertiesGrid"), {
        children: formattedAttributes.map(function (attribute, index) {
          var _a;

          return react_1.createElement("div", Object.assign({}, getStyles("propertiesItem"), {
            key: "".concat((_a = data === null || data === void 0 ? void 0 : data.nft) === null || _a === void 0 ? void 0 : _a.tokenId).concat(index)
          }), (attribute === null || attribute === void 0 ? void 0 : attribute.trait_type) && jsx_runtime_1.jsx("span", Object.assign({}, getStyles("propertiesLabel"), {
            children: attribute === null || attribute === void 0 ? void 0 : attribute.trait_type
          }), void 0), (attribute === null || attribute === void 0 ? void 0 : attribute.value) && jsx_runtime_1.jsx("span", {
            children: attribute === null || attribute === void 0 ? void 0 : attribute.value
          }, void 0));
        })
      }), void 0)
    }), void 0);
  };

  var getContent = function getContent() {
    var _a;

    if (data && metadata !== undefined && "attributes" in metadata) {
      return renderAttributes(metadata === null || metadata === void 0 ? void 0 : metadata.attributes);
    } else if (data && metadata !== undefined && "traits" in metadata) {
      return renderAttributes(metadata === null || metadata === void 0 ? void 0 : metadata.traits);
    } else if (data && metadata === undefined && "openseaInfo" in data) {
      // @ts-ignore
      return renderAttributes((_a = data === null || data === void 0 ? void 0 : data.openseaInfo) === null || _a === void 0 ? void 0 : _a.traits);
    } else {
      return jsx_runtime_1.jsx(react_2.Fragment, {}, void 0);
    }
  };

  return data ? getContent() : null;
};

exports.NFTProperties = NFTProperties;